<template>
  <div 
    id="OrdersMenu"
    class="left-menu"
  >
    <div class="nav-sub">
      <h4>{{ getContentItem('ordersButton') }}</h4>
      <ul>
        <li v-if="IsOrdersOpenOrdersSectionEnabled">
          <router-link :to="{ name: 'Orders' }">
            {{ getContentItem("ordersButton") }}
          </router-link>
        </li>
        <li v-if="IsOrdersBackOrdersSectionEnabled">
          <router-link
            :to="{ name: 'Backorders' }"
          >
            {{ getContentItem("backordersButton") }}
          </router-link>
        </li>
        <li v-if="IsOrdersInvoicesSectionEnabled">
          <dn-router-link 
            :title="getContentItem('invoicesButton')"
            url="/orders/invoices"
          />
        </li>
        <li v-if="IsOrdersCreditsSectionEnabled">
          <router-link :to="{ name: 'Credits' }">
            {{ getContentItem("creditsButton") }}
          </router-link>
        </li>
        <li v-if="IsPartsStoreOrdersSectionEnabled && hasPermission('IsNGaugeOrderAdmin')">
          <router-link to="/partsStore/Orders/Index">
            Parts Store Orders
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import { mapGetters }         from "vuex";
  import { siteSectionsHelper } from "@/components/mixins/siteSectionsHelper"
  import { DnRouterLink } from "@/components/Elements"

  export default {
    name: "OrdersMenu",
    components: {
      DnRouterLink
    },
    mixins: [siteSectionsHelper],
    computed: {
      ...mapGetters(["getContentItem", "hasPermission"]),
    },
  };
</script>